import styled from 'styled-components';

const BannerImage = styled.img`
  display: block;
  border-radius: 20px;
  box-shadow: 0 0 4px rgba(0, 0, 0, .15);
  user-select: none;
  opacity: ${props => props.disabled ? 0.6 : 1};
  filter: ${props => props.disabled && 'grayscale()'};
  max-width: 100%;
  height: auto;
`;

export default BannerImage;
